module.exports = __webpack_public_path__ + "static/img/14000335.e3d49f76.png";